import { useInfiniteQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

interface IProps {
  limit?: number;
  filters: {
    group_uid_ne?: string;
    username?: string;
    name__contains?: string;
  };
}

export const useUsersQuery = ({ limit, filters }: IProps) => {
  return useInfiniteQuery({
    queryKey: ['getUsers', filters?.name__contains],
    queryFn: async ({ pageParam = 0 }) => {
      return await Api.users.getUsers({
        offset: pageParam,
        limit: limit || 0,
        group_uid_ne: filters.group_uid_ne,
        username: filters.username,
        name__contains: filters.name__contains,
      });
    },
    getNextPageParam: (current, allPages) => {
      const count = allPages.length * (limit || 1);
      return count >= (current.total || 0) ? undefined : count;
    },
  });
};
